import { StandardQuizQuestion } from '@/types/quizTypes';

export const ADVANCED_RL_ALGORITHMS_QUIZ: StandardQuizQuestion[] = [
  {
    id: "adv-rl-1",
    question: "What is Deep Q-Network (DQN)?",
    options: [
      "A database technology",
      "Q-learning with deep neural networks for function approximation",
      "A cloud service",
      "A programming language"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "DQN combines Q-learning with deep neural networks to handle high-dimensional state spaces (like images). It uses experience replay and target networks for stability.",
    category: "deep-rl",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "adv-rl-2",
    question: "What is Policy Gradient method?",
    options: [
      "A security protocol",
      "Directly optimizing policy parameters using gradient ascent",
      "A database optimization",
      "A network routing algorithm"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Policy Gradient methods directly parameterize and optimize the policy using gradient ascent on expected reward. REINFORCE is a classic algorithm in this family.",
    category: "policy-based",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "adv-rl-3",
    question: "What is Actor-Critic architecture?",
    options: [
      "Movie rating system",
      "Combines policy (actor) and value function (critic) learning",
      "Cloud architecture",
      "Database design"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "Actor-Critic uses two networks: the actor learns the policy (what to do), and the critic learns the value function (how good is it), providing lower-variance policy updates.",
    category: "actor-critic",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "adv-rl-4",
    question: "What is PPO (Proximal Policy Optimization)?",
    options: [
      "A cloud provider",
      "Policy gradient algorithm with clipped objectives for stable updates",
      "A database query",
      "A network protocol"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "PPO is a popular policy gradient algorithm that constrains policy updates to a trust region, preventing destructively large updates. It's simpler than TRPO and widely used in practice.",
    category: "modern-algorithms",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "adv-rl-5",
    question: "What is DDPG (Deep Deterministic Policy Gradient)?",
    options: [
      "A programming language",
      "Actor-critic algorithm for continuous action spaces",
      "A cloud service",
      "A database system"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "DDPG extends DQN to continuous action spaces using an actor-critic architecture. It's deterministic (no randomness in actions) and uses experience replay and target networks.",
    category: "continuous-control",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "adv-rl-6",
    question: "What is SAC (Soft Actor-Critic)?",
    options: [
      "A security framework",
      "Maximum entropy RL algorithm balancing reward and exploration",
      "A testing tool",
      "A monitoring system"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "hard",
    explanation: "SAC is an off-policy algorithm that maximizes both reward and entropy (randomness). This encourages exploration and leads to more robust policies. It's state-of-the-art for many continuous control tasks.",
    category: "modern-algorithms",
    points: 20,
    type: "multiple-choice"
  },
  {
    id: "adv-rl-7",
    question: "What is Multi-Agent Reinforcement Learning (MARL)?",
    options: [
      "Running multiple copies of same agent",
      "Multiple agents learning simultaneously in shared environment",
      "Cloud load balancing",
      "Database replication"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "MARL involves multiple agents learning concurrently in the same environment. They may cooperate, compete, or both, requiring techniques to handle non-stationary environments and credit assignment.",
    category: "multi-agent",
    points: 15,
    type: "multiple-choice"
  },
  {
    id: "adv-rl-8",
    question: "What is Transfer Learning in RL?",
    options: [
      "Moving data between servers",
      "Applying knowledge from one task to accelerate learning in another",
      "Network optimization",
      "Database migration"
    ],
    correctAnswer: 1,
    correctAnswerIndex: 1,
    difficulty: "medium",
    explanation: "Transfer Learning in RL reuses knowledge (policies, value functions, representations) from a source task to speed up learning in a related target task, reducing sample complexity.",
    category: "transfer-learning",
    points: 15,
    type: "multiple-choice"
  }
];

export const generateAdvancedRlAlgorithmsQuiz = () => ({
  questions: ADVANCED_RL_ALGORITHMS_QUIZ,
  passThreshold: 75,
  timeLimit: 1200,
  category: 'advanced-rl'
});
